var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAirConditioning = function SvgAirConditioning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 8"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "CurrentColor",
    d: "M12.667 0H1.333a1 1 0 0 0-1 1v5.333a1 1 0 0 0 1 1h11.334a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1Zm-2.333.667v1A.333.333 0 0 1 10 2H4a.333.333 0 0 1-.333-.333v-1h6.667Zm1.333 4.666H2.333v-.666h9.334v.666ZM2.333 6.667V6h9.334v.667H2.333ZM13 6.333a.333.333 0 0 1-.333.334h-.333V4.333A.333.333 0 0 0 12 4H2a.333.333 0 0 0-.333.333v2.334h-.334A.333.333 0 0 1 1 6.333V1a.333.333 0 0 1 .333-.333H3v1a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-1h1.667A.333.333 0 0 1 13 1v5.333Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "CurrentColor",
    d: "M12 2.667h-.667a.333.333 0 1 0 0 .666H12a.333.333 0 1 0 0-.666Z"
  })));
};
export default SvgAirConditioning;